const Garansi6BulanIcon = ({ className }) => {
  return (
    <svg
      width="83"
      className={className}
      height="61"
      viewBox="0 0 83 61"
      fill="none"
      xmlns="http://www.w3.org/2000/svg">
      <path
        d="M65.2878 33.8604C65.2878 36.2922 63.2925 38.2875 60.8607 38.2875C58.4289 38.2875 56.4336 36.2922 56.4336 33.8604C56.4336 31.4286 58.4289 29.4333 60.8607 29.4333C63.2925 29.4333 65.2878 31.4286 65.2878 33.8604Z"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M56.4336 33.8605V27.8121C56.4336 25.1933 58.5536 23.0732 61.1725 23.0732C62.2949 23.0732 63.4172 23.5097 64.2278 24.1956"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M65.287 10.4778C65.5364 11.039 65.6611 11.6625 65.6611 12.286C65.6611 14.9049 63.5411 17.0873 60.8598 17.0873C58.241 17.0873 56.0586 14.9673 56.0586 12.286C56.0586 11.6625 56.1833 11.039 56.4327 10.4778"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M60.8594 12.2237V1"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M64.7268 5.67661H74.9528C78.2576 5.67661 81.0011 8.35783 81.0011 11.7249V53.8138C81.0011 57.1185 78.3199 59.8621 74.9528 59.8621H46.7065C43.4018 59.8621 40.6582 57.1809 40.6582 53.8138V11.6626C40.6582 8.35783 43.3394 5.61426 46.7065 5.61426H56.9326"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.421 32.1145H27.2527C25.8185 32.1145 24.5091 31.6156 23.4491 30.618L20.8926 28.2485"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.2266 38.1629L17.6467 39.1606C19.5173 39.41 20.8891 41.0312 20.8891 42.9018V44.7724H10.2266"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49219 33.8605V51.5066"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M4.49182 33.611L1.56118 30.431C1.18706 30.1192 1 29.6204 1 29.1839V25.6921C1 24.7568 1.74825 23.9462 2.74591 23.9462H9.48012L15.279 12.7848C16.4014 11.2883 18.2097 10.353 20.1426 10.353H35.1076H35.9182"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.2796 51.2572V51.9431C15.2796 54.9361 12.8478 57.3055 9.91712 57.3055C6.92413 57.3055 4.55469 54.8737 4.55469 51.9431V51.2572"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M35.4175 51.2572H10.2266"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M30.8672 44.7723H35.1073"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.5918 24.0085H35.7321"
        stroke="#344154"
        strokeWidth="2"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.4589 14.9674L15.9023 19.8933H32.9873V14.2191H20.1424C19.4565 14.2191 18.8953 14.4685 18.4589 14.9674Z"
        fill="#E12B25"
      />
      <path
        d="M56.8063 48.4512C56.9933 48.7007 57.1181 49.0124 57.1181 49.3865C57.1181 49.9477 56.8686 50.3842 56.4322 50.696C55.9957 51.0077 55.3098 51.1325 54.4368 51.1325H50.8203V44.8347H54.2498C55.1227 44.8347 55.7463 44.9594 56.1827 45.2712C56.6192 45.583 56.8063 45.9571 56.8063 46.4559C56.8063 46.7677 56.7439 47.0171 56.5569 47.2665C56.4322 47.5159 56.1827 47.703 55.871 47.8277C56.3075 48.0148 56.6192 48.2018 56.8063 48.4512ZM52.9403 46.3312V47.2665H53.938C54.4368 47.2665 54.6239 47.0795 54.6239 46.7677C54.6239 46.4559 54.4368 46.3312 53.938 46.3312H52.9403ZM54.9357 49.1995C54.9357 48.8877 54.6863 48.7007 54.2498 48.7007H52.9403V49.6983H54.2498C54.6863 49.6983 54.9357 49.5113 54.9357 49.1995Z"
        fill="#344154"
      />
      <path d="M57.8652 44.8347H60.0476V49.5736H62.9159V51.2572H57.8652V44.8347Z" fill="#344154" />
      <path
        d="M69.7763 44.8347V51.1948H68.0303L65.5985 48.3265V51.1948H63.4785V44.8347H65.2244L67.6562 47.703V44.8347H69.7763Z"
        fill="#344154"
      />
    </svg>
  )
}

export default Garansi6BulanIcon
